import { mainLocator as locator } from '@core/di/main.locator';
import { UiService } from '@core/services/ui.services';
import UserProfileRepository from '@modules/main/pages/user-profile/user-profile.repository';
import { UserProfileStore } from '@modules/main/pages/user-profile/user-profile.store';

locator.register('UserProfileRepository', UserProfileRepository);
locator.registerInstance(
  'UserProfileStore',
  new UserProfileStore(
    locator.resolve<UiService>('UiService'),
    locator.resolve<UserProfileRepository>('UserProfileRepository'),
  ),
);
